import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

// 阻止路由重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: '/tutors',
    },
    {
        path: '/',
        name: 'Home',
        meta: {
            title: '首页'
        },
        component: () =>
            import('../views/Home.vue'),
        children: [
            {
                path: '/briefIntroduction',
                name: 'briefIntroduction',
                meta: {
                    title: '导师简介'
                },
                component: () =>
                    import('../views/briefIntroduction/briefIntroduction'),
            },
            {
                path: '/tutors',
                name: 'tutors',
                meta: {
                    title: '导师风采主页'
                },
                component: () =>
                    import('../views/tutors/tutors'),
            },
        ]
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     meta: {
    //         title: '登录',
    //     },
    //     component: () =>
    //         import('../views/Login.vue')
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: "push",
    routes,
    scrollBehavior(to, from, savePotion) {
        if (savePotion) {
            return savePotion
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})
// 前置守卫
// router.beforeEach((to, from, next) => {
//     if (!store.getters.getUserData.name && to.path !== '/login') {
//         next('/login')
//     } else if (to.path === '/login' && store.getters.getUserData.name) {
//         next(from.path)
//     } else {
//         next()
//     }
// })
export default router